module.exports = __webpack_public_path__ + "static/resources-list-2-bd1257196e09e3307fc951af9fb1f589.png";